import Header from "../../../../layouts/header/Header";
import Footer from "../../../../layouts/footer/Footer";
import HeadingComponent from "../HeadingComponent";
import { Button } from "../../../../shadcn/components/ui/button";
import FAQAccordian from "../../home/faq/FAQAccordian";
import { useRouter } from "next/router";

interface FaqContent {
  questionText?: string;
  answerText?: string;
  value?: string;
}

const faqContent: FaqContent[] = [
  {
    questionText: "What is e-Auction?",
    answerText:
      "Property eAuction refers to the process of auctioning properties online through an electronic platform.",
    value: "item-1",
  },
  {
    questionText: "Who is Bidder?",
    answerText:
      "Anyone, be it a company or an individual wishing to bid or participate in an online Auction event, is a Bidder.",
    value: "item-2",
  },
  {
    questionText: "Are Auction Events Private Or Public?",
    answerText:
      "The auction event is public. Anyone can register on the portal and participate in the bidding process by adhering to the pre-bid formalities as prescribed by the auctioning institute or its authorized officer.",
    value: "item-3",
  },
  {
    questionText: "How Can a Bidder Register in the Auction Portal?",
    answerText:
      "To participate as a Bidder, Registration is a simple process. Go to the registration form from the Home page. Select 'Register as Individual or Company' and fill out all required details and complete eKYC online.",
    value: "item-4",
  },
  {
    questionText:
      "Can an individual who is not a registered company or organization register as a Bidder?",
    answerText:
      "Yes, an Individual can register as a Bidder on the Auction platform. While registering, please select 'Individual' in the Bidder Details Field.",
    value: "item-5",
  },
  {
    questionText: "Forgotten username and/or password: How to retrieve it?",
    answerText:
      "Click on 'Forgot Password' link provided on the Login page. You will be required to provide your registered email id.",
    value: "item-6",
  },
  {
    questionText:
      "What is the internet connection requirement for smooth working of e-Auctions?",
    answerText:
      "It is recommended to have an uninterrupted internet connection with a speed of 256 KBPs or higher; please ensure that during the Auction process the internet connection should not go off.",
    value: "item-7",
  },
  {
    questionText: "How can a Bidder participate in an Auction?",
    answerText:
      "A Bidder should be registered and then pay off the EMD amount to be able to participate in bidding of any auction.",
    value: "item-8",
  },
  {
    questionText: "What is an Addendum?",
    answerText:
      "An Addendum, sometimes referred to as an Amendment Sheet, is a list of changes that have been notified after the auction has been published.",
    value: "item-9",
  },
  {
    questionText: "What is an auctioned property?",
    answerText:
      "Banks usually auction properties under the provisions and the procedure prescribed under the SARFAESI Act. Properties are auctioned when borrowers fail to pay back loans after mortgaging them.",
    value: "item-10",
  },
  {
    questionText: "Why is it auctioned?",
    answerText:
      "Bank auctions are initiated when a borrower defaults on three consecutive Home Loan EMIs. A notice is served to the customer to respond within 60 days, after which the bank can auction the property.",
    value: "item-11",
  },
  {
    questionText: "How to find such properties?",
    answerText:
      "These notices are generally published in newspapers, however auctionbazaar.com makes it simple for its users to access most of these notices in their portal and users can access these notices without any fee or subscription.",
    value: "item-12",
  },
  {
    questionText: "Inspect the Physical Condition of the Property",
    answerText:
      "To inspect the property's physical condition, either you can contact the Authorized officer or reach out to auctionbazaar.com on their official number by phone or WhatsApp to schedule a site visit (available for most of the banks on auctionbazaar.com).",
    value: "item-13",
  },
  {
    questionText: "Symbolic vs Physical Possession",
    answerText:
      "Symbolic possession means the bank is in the process of obtaining physical possession from the borrower, while physical possession means the bank already has direct possession of the property.",
    value: "item-14",
  },
  {
    questionText:
      "What are the risks associated with the purchase of auctioned properties?",
    answerText:
      "Buyers must verify property ownership and remember that borrowers have certain rights, such as the 'Right of Redemption' during the auction process. Auctionbazaar assists all customers in identifying associated risks when acquiring these properties.",
    value: "item-15",
  },
  {
    questionText: "What does an auction reserve price mean?",
    answerText:
      "An auction reserve price is the minimum price that a seller is willing to accept for an item being auctioned.",
    value: "item-16",
  },
  {
    questionText: "What is the meaning of “Upcoming Auctions”?",
    answerText:
      "The properties that will soon come to the auction. If you are interested, please contact the AuctionBazaar team on 8370969696.",
    value: "item-17",
  },
  {
    questionText: "What types of properties are listed on the platform?",
    answerText:
      "The platform lists a wide range of properties, including residential, commercial, industrial, agricultural, and others.",
    value: "item-18",
  },
  {
    questionText: "Where are the properties located?",
    answerText:
      "Properties are listed from urban, suburban, and rural areas. Specific locations are found within each property listing.",
    value: "item-19",
  },
  {
    questionText: "How many rooms do the properties typically have?",
    answerText:
      "The number of rooms varies from property to property. Each listing provides details about the number of bedrooms, bathrooms, and other rooms.",
    value: "item-20",
  },
  {
    questionText: "What types of ownership are available for the properties?",
    answerText:
      "Ownership types include freehold, leasehold, cooperative society, and others, with details provided in each listing.",
    value: "item-21",
  },
  {
    questionText: "What is the indicative price range for the properties?",
    answerText:
      "Price range varies depending on location, size, condition, and market value. Specific reserve prices are listed within property details.",
    value: "item-22",
  },
  {
    questionText: "How can I view additional information about a property?",
    answerText:
      "Click on the property listing to view additional details such as auction date, reserve price, property address, and uploaded photographs or videos.",
    value: "item-23",
  },
  {
    questionText: "Can I view photographs and videos of the properties?",
    answerText:
      "Yes, you can view photographs and videos uploaded by sellers within each property listing.",
    value: "item-24",
  },
  {
    questionText: "Can I schedule a viewing of the property before bidding?",
    answerText:
      "In some cases, property viewings may be available upon request. Contact the seller or auction organizer for more information.",
    value: "item-25",
  },
  {
    questionText: "What types of commercial properties are available?",
    answerText:
      "Commercial properties include offices, retail shops, malls, warehouses, and plots for development.",
    value: "item-26",
  },
  {
    questionText: "What type of industrial property information is available?",
    answerText:
      "The platform includes industrial plots, industrial sheds, and sheds with plant and machinery.",
    value: "item-27",
  },
  {
    questionText: "Can users bid online for properties shown on the portal?",
    answerText:
      "Yes, users can bid directly from the portal after registering.",
    value: "item-28",
  },
  {
    questionText: "Are there any fees associated with registering or bidding?",
    answerText: "Registration on the portal is free.",
    value: "item-29",
  },
  {
    questionText: "Is there a minimum bid requirement for properties?",
    answerText:
      "Each property auction has its own minimum bid requirement, which is stated in the listing.",
    value: "item-30",
  },
  {
    questionText: "How do I know if my bid has been successful?",
    answerText:
      "You will receive confirmation via email or notification on the portal after placing your bid.",
    value: "item-31",
  },
  {
    questionText: "Can I retract or modify my bid once it's been placed?",
    answerText:
      "No, once a bid has been submitted, it cannot be retracted or modified.",
    value: "item-32",
  },
  {
    questionText:
      "How do I contact support if I encounter any issues or have questions?",
    answerText:
      "Contact customer support via the contact information provided on the portal for assistance. (Support Number: 8370 969696)",
    value: "item-33",
  },
  {
    questionText: "What is eKYC?",
    answerText:
      "eKYC stands for electronic Know Your Customer, a process of verifying identity and address electronically.",
    value: "item-34",
  },
  {
    questionText: "What is the purpose of this Portal?",
    answerText:
      "AuctionBazaar.com provides users with a streamlined experience for accessing e-auctions facilitated by Partnering Banks and Financial Institutions. Users can easily search for properties based on type and location, simplifying the process of finding auction opportunities.",
    value: "item-35",
  },
  {
    questionText: "Does a user require registration/login to use the portal?",
    answerText:
      "No, users can access AuctionBazaar.com without registration or login. However, certain features are accessible only to logged-in users.",
    value: "item-36",
  },
  {
    questionText: "What benefits are derived from this portal?",
    answerText:
      "AuctionBazaar.com provides a streamlined experience for users to access e-auctions facilitated by Partnering Banks and Financial Institutions, offering a user-friendly property search for auction opportunities.",
    value: "item-37",
  },
  {
    questionText: "What is an eauction ID?",
    answerText:
      "The eAuction ID is a unique identifier assigned to each auction event, allowing participants and administrators to track specific events efficiently.",
    value: "item-38",
  },
  {
    questionText: "How do I identify the type of auction?",
    answerText:
      "Each auction listing includes a label or category to denote whether it is a live auction, upcoming auction, or closed auction, as well as the type of property involved.",
    value: "item-39",
  },
  {
    questionText: "Is there a mechanism for tracking favorite properties?",
    answerText:
      "Yes, users can mark properties as favorites and access them easily from their account dashboard.",
    value: "item-40",
  },
  {
    questionText: "Is it possible to get notified about upcoming auctions?",
    answerText:
      "Yes, users can subscribe to notifications and receive updates about upcoming auctions based on their interests.",
    value: "item-41",
  },
];

const FAQPage = () => {
  const router = useRouter();
  return (
    <>
      <Header />
      <HeadingComponent
        heading="FREQUENTLY ASKED QUESTIONS"
        subheading="Need help? We will be happy to assist with all your questions."
      >
        <div className="flex justify-center">
          <Button
            onClick={() => router.push("/contactus")}
            className="mt-[55px] lg:mt-[106px] w-[166px] lg:w-[218px] h-10 lg:h-14"
          >
            {" "}
            Talk to our expert
          </Button>
        </div>
      </HeadingComponent>

      <div className="px-customPaddingMobile lg:px-customPadding  2xl:px-0 2xl:w-[1340px] 2xl:mx-auto">
        <FAQAccordian faqContent={faqContent} />
      </div>
      <Footer />
    </>
  );
};

export default FAQPage;
